import { DiscoverPageContent } from "@/features";
import { useDataflowStore } from "@/stores/dataflow";
import { useEffect } from "react";
import "./DiscoverPage.css";

export function DiscoverPage() {
  const setActiveDataflow = useDataflowStore(
    (state) => state.setActiveDataflow
  );

  useEffect(() => {
    setActiveDataflow(null);
  }, [setActiveDataflow]);

  return <DiscoverPageContent />;
}
